<template>
  <el-dialog
    :close-on-click-modal="false"
    title="经停点详情"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="tableData.data"
        tooltip-effect="dark"
      >
        <!-- 选择框 -->
        <!-- <el-table-column type="selection" width="55" /> -->
        <!-- 选择框 end -->
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :sortable="item.sortable"
          :filters="item.filters"
          :filter-method="item.filterHandler"
          :min-width="item.minW"
          :width="item.w"
        />
      </el-table>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  trackInstransitLineDetail,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'regionName',
            label: '经停点',
          },
          {
            prop: 'carDependDate',
            label: '发车时间',
          },
          {
            prop: 'carStartDate',
            label: '离台时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.getDetailLoading = true;
      const res = await trackInstransitLineDetail({
        orderId: item.orderId,
      });
      this.tableData.data = res.items;
      this.getDetailLoading = false;
    },
  },
};
</script>

<style>
</style>
